import React from 'react';
import {Link} from 'react-router-dom';
import Input from 'blocks/Input';
import {inject} from 'mobx-react';
import HttpClient from 'services/HttpClient';

@inject('alert')
export default class ForgotPassword extends React.Component {

  state = {email: ''};

  handleChange = e => {
    this.setState({email: e.email})
  };

  resetEmail = e => {
    e.preventDefault();
    new HttpClient().post('/api/v1/users/forgot_password', {email: this.state.email}).then( () => {
      this.props.alert.success('Please check your email');
      this.setState({email: ''});
    }).catch( (response) => {
      console.log('error ', response)
      this.props.alert.error(response.body.error_message);
      this.setState({email: ''});
    })
  };

  render(){
    return(
      <div className="row justify-content-center align-items-center sign-up-form-holder">
        <div className="col-12 col-md-10">
          <form onSubmit={this.resetEmail}>
            <div className="row">
              <div className="col">
                <h1 className="sign-up-title">Forgot Your Password?</h1>
                <p className="sign-up-greeting">Enter your email address below and we'll send you reset link</p>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <Input name="email"
                       type="email"
                       value={this.state.email}
                       handleChange={this.handleChange}
                       placeholder="Email Address"/>
              </div>
            </div>
            <div className="btn-holder">
              <button type="submit" className="btn blue empty bordered">send reset link</button>
            </div>
            <div className="forgot-holder">
              <Link to="/newuser/signin" className="forgot">BACK TO SIGN IN</Link>
              <p style={{fontSize: 15, margin: '5px 0', color: '#08c' }}>To reset your IACP password do so via <a href='www.iacp.ie' target='_blank'>www.iacp.ie</a></p>
            </div>
          </form>
        </div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/new_user/ForgotPassword.jsx